import { useState, useEffect } from "react";
import "./systemStatusWidget.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";

const SystemStatusWidget = () => {
  const [systemStatus, setSystemStatus] = useState("Loading...");
  const [isOperational, setIsOperational] = useState(false);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        // Use a timeout to ensure the fetch doesn't hang indefinitely
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Request timeout')), 5000)
        );
        
        // Use no-cors mode to avoid CORS issues
        // Note: This makes the response "opaque" - can't read status or body
        const fetchPromise = fetch("https://status.laddersuite.com/status/fres", {
          mode: "no-cors"
        });
        
        // Race the fetch against the timeout
        await Promise.race([fetchPromise, timeoutPromise]);
        
        // If we reach here, we were able to at least contact the server
        // We can't check response.ok because of no-cors mode
        setIsOperational(true);
        setSystemStatus("All Systems Operational");
      } catch (error) {
        console.error("Detailed error:", {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        
        // If we can't reach the status page, we'll assume there might be issues
        setSystemStatus("Degraded Service");
        setIsOperational(false);
      }
    };

    // Check immediately and then every 5 minutes
    checkStatus();
    const interval = setInterval(checkStatus, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="systemStatusWidget">
      <div className="title">PSAPLink Status</div>
      <div className={`status ${isOperational ? "operational" : "degraded"}`}>
        {isOperational ? (
          <CheckCircleIcon className="icon" />
        ) : (
          <WarningIcon className="icon" />
        )}
        <span className="text">{systemStatus}</span>
      </div>
    </div>
  );
};

export default SystemStatusWidget;
